import { render, staticRenderFns } from "./KUserChallengesList.vue?vue&type=template&id=c51fb6b2&"
import script from "./KUserChallengesList.vue?vue&type=script&lang=js&"
export * from "./KUserChallengesList.vue?vue&type=script&lang=js&"
import style0 from "./KUserChallengesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports